import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { AcceptReturnRequestDto } from "../generated/schema";
import useInvalidateReturnRequests from "./use-invalidate-return-requests";
import useInvalidateShop from "./use-invalidate-shop";

interface UseAcceptReturnRequestParams {
	onSuccess?: () => void;
	onMutate?: () => void;
	onError?: () => void;
	shopId: string;
}

export default function useAcceptReturnRequest(
	params: UseAcceptReturnRequestParams,
) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();
	const invalidateReturnRequests = useInvalidateReturnRequests();
	const invalidateShop = useInvalidateShop(params.shopId);
	const mutation = $api.useMutation(
		"post",
		"/shops/{shopId}/return-requests/{returnRequestId}/accept",
	);

	return useMutation({
		onMutate: params.onMutate,
		onSuccess: () => {
			invalidateShop();
			successNotification();
			invalidateReturnRequests();
			params.onSuccess?.();
		},
		onError: () => {
			params.onError?.();
			errorNotification();
		},
		mutationFn: async ({
			variables,
			returnRequestId,
		}: {
			variables: AcceptReturnRequestDto;
			returnRequestId: string;
		}) => {
			return mutation.mutateAsync({
				params: { path: { shopId: params.shopId, returnRequestId } },
				body: variables,
			});
		},
	});
}
